











































import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CheckTree from '@/app/shared/models/CheckTree';
import CheckTreeItem from '@/app/shared/models/CheckTreeItem';
import { ChapterItem } from '@/app/shared/models/reports/ChapterItem';
import { ChapterItemType } from '@/app/shared/enums/chapter-item-type.enum';
import { UpdateChapterItemPayload } from '@/app/shared/store/modules/reports.store-module';
import { GRAPHIK_FONT_FAMILY_FOR_HTML_STYLE } from '@/app/shared/store/modules/presentations.constants';
import api from '@/app/shared/api';

const ReportsStore = namespace('Reports');

const util = {
  enumerateChecktree(checktree: CheckTree, node: CheckTreeItem) {
    if (node) {
      if (node.children) {
        node.children.forEach((el, index) => {
          el.presentationEnumeration = node.presentationEnumeration + '.' + ++index;
          this.enumerateChecktree(checktree, el);
        });
      }
    } else {
      // root level
      checktree.children.forEach((el: any, index: number) => {
        el.presentationEnumeration = (index + 1).toString();
        this.enumerateChecktree(checktree, el);
      });
    }
  },
};

@Component({
  components: {},
})
export default class SingleImpactChecktreeTable extends Vue {
  @Prop() item: ChapterItem;

  tableData: CheckTreeItem[] = [];
  borderColor: string = '#D3DADC';
  cellColor: string = 'white';
  shouldShowComments: boolean = true;
  sizeMode: 'half' | 'full' = 'full';
  shouldEnumerate: boolean = true;

  ChapterItemType: ChapterItemType;

  style = {
    topBorder: { borderRadius: '2px 2px 0 0', height: '8px', background: '#D3DADC' },
    tableRow: {
      background: 'white',
      textAlign: 'left',
      color: '#222C37',
      borderBottom: '1px solid #D3DADC',
      '--row-font-size': '14px',
      '--row-line-height': '18px',
    },
    rowTitle: {
      margin: '0 16px',
      fontSize: 'var(--row-font-size)',
      lineHeight: 'var(--row-line-height)',
      letterSpacing: '0.25px',
      fontWeight: '500',
    },
    rowComment: {
      paddingTop: '8px',
      margin: '0 2rem',
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '0.25px',
    },
  };

  @ReportsStore.Getter
  public getParagraphs!: ChapterItem[];

  @ReportsStore.Action
  public updateChapterItem!: (payload: UpdateChapterItemPayload) => Promise<any>;

  @ReportsStore.Action
  public lockChapterItem!: (uuid: string) => Promise<any>;

  @ReportsStore.Action
  public unlockChapterItem!: (uuid: string) => Promise<any>;

  async initiateTableData(payload: any) {
    const addItem = (items: CheckTreeItem[], node: CheckTreeItem) => {
      items.push(node);
      if (node.children) {
        for (const childItem of node.children) {
          addItem(items, childItem);
        }
      }
    };

    // Load MM/MA Checktree data.
    const data: any = await api.reports.getImpactChecktreeTableData(payload.uuid, payload.field, payload.fromMatrix);

    if (data.children) {
      util.enumerateChecktree(data, null);
      for (const rootItem of data.children) {
        addItem(this.tableData, rootItem);
      }
    }
  }

  created() {
    let payload: any = null;
    if (this.item.payload) {
      payload = this.item.payload;
    } else {
      payload = {
        uuid: this.$route.params.uuid,
        field: this.item.table_type,
        fromMatrix: this.$route.query.fromMatrix as string,
      };
    }

    this.initiateTableData(payload).then(() => {
      this.updateTableHTML(payload);
    });
  }

  async updateTableHTML(payload: any) {
    try {
      const html = `
        <!DOCTYPE html>
        <html>
          <head>
            <style>
              ${GRAPHIK_FONT_FAMILY_FOR_HTML_STYLE}
              * {
                font-family: 'Graphik', Avenir, Helvetica, Arial, sans-serif;
              }
            </style>
          </head>
          <body>
            ${(this.$refs.screeningTable as HTMLElement).innerHTML}
          </body>
        </html>
        `;

      const additionalProperties = [
        {
          name: 'payload',
          value: JSON.stringify(payload),
        },
      ];

      if (this.item.html != html) {
        await this.lockChapterItem(this.item.uuid);
        await this.updateChapterItem({
          uuid: this.item.uuid,
          type: ChapterItemType.IMPACT_TABLE,
          propertyName: 'html',
          propertyValue: html,
          additionalProperties,
        });
        await this.unlockChapterItem(this.item.uuid);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
